import {API_ENDPOINT_JSON} from '../../../../../config';

export const getCbamIronAndSteelUrl = (pillarId: string): string => {
  return `${API_ENDPOINT_JSON.ESG.CBAM_IRON_AND_STEEL_.ironAndSteel}/${pillarId}`;
};
